import { useState } from "react";

import { useEffect } from "react";
import { Breakpoint } from "../constants";

type BreakpointDirection = "up" | "down";

export function useBreakpoint(
  breakpoint: Breakpoint,
  direction: BreakpointDirection = "down"
) {
  const query =
    direction === "down"
      ? `(max-width: ${breakpoint}px)`
      : `(min-width: ${breakpoint}px)`;

  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia(query);
    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, [query]);

  return matches;
}
